import {put, takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';
import {fetchUnreadNotifications} from '../creators/user.unreadNotification'
import {TYPES as NOTIFICATIONS_TYPES} from '../creators/user.notifications';

export function* onFetch(action) {
    try {
        yield put(fetchUnreadNotifications());
    } catch (error) {
        console.log(error);
    }
}

export function* watchNotificationsFetching() {
    yield takeEvery(NOTIFICATIONS_TYPES.GET_SUCCESS, onFetch);
}

export default watchNotificationsFetching;

